import { ParsedColor } from '@/types/colors.types';

const parseColor = (color: string): ParsedColor | null => {
  const testElement = document.createElement('span');
  testElement.style.color = color;
  document.body.appendChild(testElement);

  const rgbColor = getComputedStyle(testElement).color;
  document.body.removeChild(testElement);

  const rgbMatch = rgbColor.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);

  if (!rgbMatch) {
    console.error('Unsupported color format', color);
    return null;
  }

  const r = parseInt(rgbMatch[1], 10);
  const g = parseInt(rgbMatch[2], 10);
  const b = parseInt(rgbMatch[3], 10);
  const a = rgbMatch[4] ? parseFloat(rgbMatch[4]) : 1;

  return { r, g, b, a };
};

export const addAlphaToColor = (color: string, alphaIncrement: number): string => {
  const parsed = parseColor(color);

  if (!parsed) {
    return 'rgba(0, 0, 0, .2)';
  }

  const { r, g, b } = parsed;
  const newAlpha = Math.min(Math.max(alphaIncrement, 0), 1);

  return `rgba(${r}, ${g}, ${b}, ${newAlpha})`;
};
